import imageUrlBuilder from "@sanity/image-url";

export function imageUrlFor(source, clientConfig) {
  const builder = imageUrlBuilder(clientConfig.sanity);
  return builder.image(source);
}
